import { OS } from "@/lib/utils/getDeviceOs";
import { RedirectionUrls } from "@/components/redirectFlow/ClientRedirect.types";

/**
 * Pick where this visitor should be sent. `undefined` means no destination
 * exists for their OS at all — the caller surfaces that as a failure instead of
 * leaving them on a spinner.
 */
export function resolveRedirectionUrl(
  os: OS,
  { web, ios, android }: RedirectionUrls
): string | undefined {
  // The store URLs are null when the app has no id for that store, so a mobile
  // visitor falls through to the web destination rather than being sent to a
  // dead store page. Mirrors resolveDestination in /api/link/continue.
  if (os === "ios" && ios) return ios;
  if (os === "android" && android) return android;
  if (web) return web;

  // web but fallback doesn't exist, try store redirects before failing
  if ((os === "windows" || os === "linux") && android) return android;
  if (os === "mac os" && ios) return ios;

  return undefined;
}
